/**
 * Account drawer: mini-cart style slide only.
 * Also cleans Shopify's scroll-lock leftovers (extra scrollbar / stuck overflow).
 */
;(function () {
  var DRAWER_MS = 500
  var EASE = 'transform 0.5s cubic-bezier(0.24, 0.25, 0, 1)'
  var activeAccount = null
  var activeDialog = null

  function getDialog(account) {
    return account.shadowRoot && account.shadowRoot.querySelector('dialog')
  }

  function pathIncludesDialog(event, dialog) {
    if (!dialog) return false
    var path = event.composedPath ? event.composedPath() : []
    for (var i = 0; i < path.length; i++) {
      if (path[i] === dialog) return true
      if (path[i] && path[i].classList && path[i].classList.contains('dialog')) return true
    }
    return false
  }

  var savedScrollY = 0

  // Shopify locks the page with overflow:hidden on <html>. The theme's body
  // overflow then turns <body> into its own scroll box (extra scrollbar, view
  // jumps to the top), so body must stay non-scrolling while the drawer is open.
  function lockPageScroll() {
    if (document.documentElement.classList.contains('ns-account-drawer-open')) return
    savedScrollY = window.scrollY
    document.documentElement.classList.add('ns-account-drawer-open')
  }

  function unlockPageScroll() {
    if (!document.documentElement.classList.contains('ns-account-drawer-open')) return
    document.documentElement.classList.remove('ns-account-drawer-open')
    ;['overflow', 'touch-action', 'scrollbar-gutter'].forEach(function (prop) {
      document.documentElement.style.removeProperty(prop)
    })
    if (window.scrollY !== savedScrollY) window.scrollTo(0, savedScrollY)
  }

  function setDrawerTransform(dialog, value, withTransition) {
    if (!dialog) return
    dialog.style.setProperty('animation', 'none', 'important')
    dialog.style.setProperty('opacity', '1', 'important')
    dialog.style.setProperty('transition', withTransition ? EASE : 'none', 'important')
    dialog.style.setProperty('transform', value, 'important')
  }

  function slideIn(dialog) {
    if (!dialog || dialog.dataset.nsSliding === '1') return
    dialog.dataset.nsSliding = '1'
    lockPageScroll()
    setDrawerTransform(dialog, 'translateX(100%)', false)
    void dialog.offsetWidth
    requestAnimationFrame(function () {
      setDrawerTransform(dialog, 'translateX(0)', true)
      window.setTimeout(function () {
        dialog.dataset.nsSliding = '0'
      }, DRAWER_MS)
    })
  }

  function clearDrawerStyles(dialog) {
    if (!dialog) return
    dialog.style.removeProperty('transform')
    dialog.style.removeProperty('transition')
    dialog.style.removeProperty('animation')
    dialog.style.removeProperty('opacity')
  }

  var CLOSE_SELECTOR = '#close-button, .account__close, [aria-label*="λείσιμο"], [aria-label*="lose"]'

  // Closing must go through Shopify's own close button: calling dialog.close()
  // behind its back desyncs the component and crashes the tab.
  function finishClose(dialog) {
    if (!dialog) return
    unlockPageScroll()
    setDrawerTransform(dialog, 'translateX(100%)', false)
    var root = dialog.getRootNode()
    var closeBtn = root && root.querySelector ? root.querySelector(CLOSE_SELECTOR) : null
    dialog.dataset.nsPassClose = '1'
    if (closeBtn) closeBtn.click()
    window.setTimeout(function () {
      dialog.dataset.nsPassClose = '0'
      dialog.dataset.nsClosing = '0'
      if (!dialog.open) clearDrawerStyles(dialog)
    }, 100)
    activeAccount = null
    activeDialog = null
  }

  function animateClose(dialog) {
    if (!dialog || dialog.dataset.nsClosing === '1') return
    dialog.dataset.nsClosing = '1'
    setDrawerTransform(dialog, 'translateX(100%)', true)
    window.setTimeout(function () {
      finishClose(dialog)
    }, DRAWER_MS + 50)
  }

  function matchThemeButtons(account) {
    var root = account.shadowRoot
    if (!root) return
    var style = root.getElementById('netsteps-account-theme')
    if (!style) {
      style = document.createElement('style')
      style.id = 'netsteps-account-theme'
      root.appendChild(style)
    }
    style.textContent = [
      '.dialog{height:100%;max-height:100%;box-sizing:border-box;display:flex;flex-direction:column;overflow:auto;',
      'opacity:1!important;animation:none!important;',
      'transition:transform 0.5s cubic-bezier(0.24,0.25,0,1)!important}',
      '.dialog[open]{opacity:1!important;animation:none!important}',
      '.dialog::backdrop{background:rgba(0,0,0,0.12);opacity:1}',
      '.account{height:100%;min-height:100%;display:flex;flex-direction:column;box-sizing:border-box}',
      '.account__header-region{flex:0 0 auto}',
      '.account__content{flex:1 1 auto;display:flex;flex-direction:column}',
      '.account__menu-region{flex:0 0 auto}',
      '.button.outline,.account__item{font-weight:500;letter-spacing:1.6px;text-transform:uppercase;min-width:0;box-sizing:border-box}',
      '.stack-inline{max-width:100%;min-width:0}',
      '.stack-inline>*{min-width:0}',
      '.account__content:has(.account__login-slot:not([hidden])) .account__menu-region{display:none!important}'
    ].join('')
  }

  var EMAIL_HINT =
    (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0
      ? "Enter your email and we'll send you a verification code"
      : 'Πληκτρολόγησε το email σου και θα σου στείλουμε έναν κωδικό επιβεβαίωσης'

  function addEmailHint(root) {
    var loginForm = root && root.querySelector('shopify-login-form')
    var formRoot = loginForm && loginForm.shadowRoot
    var form = formRoot && formRoot.querySelector('.login-form__email-form')
    if (!form) return false
    // The login form re-renders its shadow content, wiping injected nodes.
    if (!formRoot.nsHintObserved) {
      formRoot.nsHintObserved = true
      new MutationObserver(function () {
        insertEmailHint(formRoot)
      }).observe(formRoot, { childList: true, subtree: true })
    }
    insertEmailHint(formRoot)
    return true
  }

  function insertEmailHint(formRoot) {
    var form = formRoot.querySelector('.login-form__email-form')
    if (!form) return
    var hint = formRoot.querySelector('.ns-email-hint')
    if (hint && hint.previousElementSibling === form) return
    if (!hint) {
      hint = document.createElement('p')
      hint.className = 'ns-email-hint'
      hint.textContent = EMAIL_HINT
    }
    form.insertAdjacentElement('afterend', hint)
    if (!formRoot.querySelector('#ns-email-hint-style')) {
      var style = document.createElement('style')
      style.id = 'ns-email-hint-style'
      style.textContent =
        '.ns-email-hint{display:block!important;margin:8px 0 0;font-size:12px;line-height:1.4;opacity:0.75}'
      formRoot.appendChild(style)
    }
  }

  // The login form renders into its own shadow root after the dialog opens.
  function watchEmailHint(root) {
    if (addEmailHint(root) || root.nsHintPolling) return
    root.nsHintPolling = true
    var tries = 0
    var timer = window.setInterval(function () {
      tries += 1
      if (addEmailHint(root) || tries > 40) {
        window.clearInterval(timer)
        root.nsHintPolling = false
      }
    }, 100)
  }

  function stripGreekTonos(text) {
    return String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  }

  function applyAccountCopyTweaks(root) {
    if (!root) return
    var heading = root.querySelector('.account__heading')
    if (heading && heading.textContent && heading.textContent.indexOf('Γεια σας') !== -1) {
      heading.textContent = heading.textContent.replace(/Γεια σας/g, 'Γεια σου')
    }
    root.querySelectorAll('.button.outline, .account__item, nav.stack-inline a').forEach(function (el) {
      var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT)
      var node
      while ((node = walk.nextNode())) {
        var next = stripGreekTonos(node.nodeValue)
        if (next !== node.nodeValue) node.nodeValue = next
      }
    })
    watchEmailHint(root)
  }

  function attachDialogWatchers(account, dialog) {
    if (!dialog || dialog.dataset.netstepsWatched) {
      if (dialog && dialog.open) {
        activeAccount = account
        activeDialog = dialog
        slideIn(dialog)
      }
      return
    }
    dialog.dataset.netstepsWatched = '1'
    applyAccountCopyTweaks(account.shadowRoot)

    dialog.addEventListener(
      'cancel',
      function (event) {
        if (dialog.dataset.nsClosing === '1') return
        event.preventDefault()
        animateClose(dialog)
      },
      true
    )

    dialog.addEventListener(
      'click',
      function (event) {
        if (dialog.dataset.nsPassClose === '1') return
        var closeBtn = event.target && event.target.closest ? event.target.closest(CLOSE_SELECTOR) : null
        if (!closeBtn) return
        if (dialog.dataset.nsClosing === '1') {
          event.preventDefault()
          event.stopImmediatePropagation()
          return
        }
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        animateClose(dialog)
      },
      true
    )

    new MutationObserver(function () {
      if (dialog.open) {
        if (dialog.dataset.nsClosing !== '1') {
          activeAccount = account
          activeDialog = dialog
          applyAccountCopyTweaks(account.shadowRoot)
          slideIn(dialog)
        }
      } else if (dialog.dataset.nsClosing !== '1') {
        clearDrawerStyles(dialog)
        unlockPageScroll()
        activeAccount = null
        activeDialog = null
      }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true })

    if (dialog.open) {
      activeAccount = account
      activeDialog = dialog
      slideIn(dialog)
    }
  }

  function watch(account) {
    matchThemeButtons(account)
    var dialog = getDialog(account)
    if (dialog) {
      attachDialogWatchers(account, dialog)
      return
    }

    if (account.dataset.nsWatchRetry === '1') return
    account.dataset.nsWatchRetry = '1'
    var tries = 0
    var timer = window.setInterval(function () {
      tries += 1
      matchThemeButtons(account)
      var d = getDialog(account)
      if (d || tries > 60) {
        window.clearInterval(timer)
        account.dataset.nsWatchRetry = ''
        if (d) attachDialogWatchers(account, d)
      }
    }, 50)
  }

  document.addEventListener(
    'click',
    function (event) {
      var account = event.target && event.target.closest ? event.target.closest('shopify-account') : null
      if (!account || !account.classList.contains('header__shopify-account')) return

      var dialog = getDialog(account)
      if (dialog && (dialog.open || pathIncludesDialog(event, dialog))) return
      if (dialog && dialog.dataset.nsClosing === '1') return

      matchThemeButtons(account)
      watch(account)
    },
    true
  )

  // Esc: Shopify sometimes leaves overflow lock stuck; always animate-close our way
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') return
      if (!activeDialog || !activeDialog.open) return
      if (activeDialog.dataset.nsClosing === '1') return
      event.preventDefault()
      event.stopImmediatePropagation()
      animateClose(activeDialog)
    },
    true
  )
})()
